<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\manageLiveCourseManual-1.png" alt="" /></div>
                <div>
                    <p>①.「ライブ講義」アイコンをクリックすると、オンラインコースのリストが表示されます。</p>
                    <p>&nbsp;&nbsp;新しい「ライブ講義」があると、アイコンの右隅に通知が表示されます。</p>
                    <p>&nbsp;&nbsp;当日の全てのライブ講義がディフォルトで初期表示されます。</p>
                    <p>②.講義名称にて対象するライブ講義を絞ることができます。</p>
                    <p>③.ステータス（すべて、終了、ライブ中、未開始）でライブ講義を絞ることができます。</p>
                    <p>④.講義の開始日、終了日でライブ講義を絞ることができます。</p>
                    <p>⑤.「検索」ボタンを押下することで検索処理を開始します。</p>
                    <p>⑥.検索条件を入力し、ライブ講義を検索した後に、「クリア」ボタンで検索条件をクリアすることができます。</p>
                    <p>⑦.未開始又は終了したすべての「ライブ講義」の「出欠一覧」を纏めてダウンロードすることができます。</p>
                    <p>⑧.このライブ講義の「出欠一覧」をダウンロードすることができます。</p>
                    <p>⑨.このライブ講義の受講対象者一覧を表示することができます。</p>
                    <p>⑩.このライブ講義の欠席者一覧を表示することができます。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/manageLiveCourse_manual.vue